import Reflux from 'reflux';
import ItemSetListData from 'shared/data/ItemSetList';
import ItemSetData from 'shared/data/ItemSet';
import ShowData from 'shared/data/Show';
import EventData from 'shared/data/Event';
import ActivityAuditData from 'shared/data/ActivityAudit';

const async = { asyncResult: true };

const FullScreenCuesheetActions = Reflux.createActions({
  clear: {},
  getShow: async,
  getShowForRemotePrompter: async,
  populate: async,
  populateForRemotePrompter: async,
  populateItemSetSubset: async,
  populateItemSetSubsetForGuest: async,
  populateItemSetSubsetBuffered: {},
  initializeTeleprompterView: async,
  populateActivityAudits: async,
  populateShowCallers: async,
  setDisplayViewColumn: {},
  selectTrackableUser: {},
  setFullScreenFeaturedCell: {},
  toggleFullScreen: {},
  togglePanel: {},
  toggleTrackingEnabled: {},
  toggleRemotePrompter: async,
  saveUserSettings: async,
  toggleAutoScrolling: {},
  stopScrolling: {},
  startScrolling: {},
  disableAutoScrolling: {},
  setFeaturedAutoScrollSpeed: {},
  setPrompterWidth: {},
  narrowPrompterWidth: {},
  widenPrompterWidth: {},
  toggleRealTime: {},
  increaseFeaturedAutoScrollSpeed: {},
  decreaseFeaturedAutoScrollSpeed: {},
  refreshAllRows: {},
  //Cells
  cellSelect: {},
  cellEdit: {},
  clearEditing: {},
  saveFeaturedColumn: {},
  saveFeaturedColumnPersistent: async,
  saveDataCellChanges: {},
  saveDataCellChangesTransient: {},
  saveDataCellChangesPersistent: async,
  updateScrollIndex: {},
  scrollToRowIdInPrompter: {},
  updateActiveRowInRowPanel: {},
  updateTrackedRowInRowPanel: {},
  clearTrackedRowInRowPanel: {},

  addColumn: {},
  addColumnPersistent: async,
  clearChangedRows: {},
  incrementZoom: {},
  decrementZoom: {},
  incrementLineHeight: {},
  decrementLineHeight: {},
  setForceOnboardingWelcome: {},
  resetPrompterTrialCountdown: {},
  applyFormatting: {},
  updateEditorDimensions: {},
  resetLastScrollIndex: {},
});

const defaultColumns = [
  'ItemNumber',
  'ItemStartTime',
  'ItemDuration',
  'ItemPresetDuration',
  'ItemTitle',
];

FullScreenCuesheetActions.initializeTeleprompterView.listenAndPromise(
  ShowData.get,
);
FullScreenCuesheetActions.getShow.listenAndPromise(ShowData.get);
FullScreenCuesheetActions.getShowForRemotePrompter.listenAndPromise(
  ShowData.getForGuest,
);
FullScreenCuesheetActions.populateShowCallers.listenAndPromise(
  (teamId, eventId) => EventData.getRolesByType(teamId, eventId, 'showCaller'),
);
FullScreenCuesheetActions.saveFeaturedColumnPersistent.listenAndPromise(
  ItemSetListData.updateUserSettings,
);

FullScreenCuesheetActions.populateItemSetSubset.listenAndPromise(
  _populateItemSetSubset,
);

FullScreenCuesheetActions.populateItemSetSubsetForGuest.listenAndPromise(
  _populateItemSetSubsetForGuest,
);

FullScreenCuesheetActions.saveDataCellChangesPersistent.listenAndPromise(
  ItemSetData.updateMultipleItemRowCells,
);
FullScreenCuesheetActions.populateActivityAudits.listenAndPromise(
  ActivityAuditData.getByItemCell,
);
FullScreenCuesheetActions.addColumnPersistent.listenAndPromise(
  ItemSetListData.createColumn,
);

/*
 * If an empty array or no argument is passed in for rows, all rows will be returned
 * If null is passed for rows, no row data will be returned
 * Else any rowIds passed will be returned
 */
function _populateItemSetSubset(teamId, eventId, showId, columns, rows) {
  columns = defaultColumns.concat(columns);
  return ItemSetListData.getSubset(teamId, eventId, showId, columns, rows);
}
function _populateItemSetSubsetForGuest(
  teamId,
  eventId,
  showId,
  columns,
  rows,
) {
  columns = defaultColumns.concat(columns);
  return ItemSetListData.getSubsetForGuest(
    teamId,
    eventId,
    showId,
    columns,
    rows,
  );
}

FullScreenCuesheetActions.populate.listenAndPromise(
  (teamId, eventId, showId) => {
    return Promise.all([
      ShowData.get(teamId, eventId, showId),
      ItemSetListData.getSubset(teamId, eventId, showId, null, null),
    ]).then((results) => {
      return {
        show: results[0],
        itemSetList: results[1],
      };
    });
  },
);

FullScreenCuesheetActions.toggleRemotePrompter.listenAndPromise(
  (teamId, eventId, showId, value) => {
    return ShowData.updateField(
      teamId,
      eventId,
      showId,
      'disableRemotePrompter',
      value,
    );
  },
);

FullScreenCuesheetActions.populateForRemotePrompter.listenAndPromise(
  (teamId, eventId, showId) => {
    return Promise.all([
      ShowData.getForGuest(teamId, eventId, showId),
      ItemSetListData.getSubsetForGuest(teamId, eventId, showId, null, null),
    ]).then((results) => {
      return {
        show: results[0],
        itemSetList: results[1],
      };
    });
  },
);

export default FullScreenCuesheetActions;
